import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

import { TicketListFilters } from '../core/models';
import { DEFAULT_INBOX_STATUS } from '../core/ticket-status';

/** Spec, §Search/filter. Server-supported at launch: status, priority,
 * assignee, date range, subject substring (Task 2's list_queue_tickets
 * extension) — free-text is scoped to SUBJECT only, not message bodies, a
 * named narrowing (a body search would need a join/index disproportionate to
 * add unannounced here). Queue scope and requester-org filtering are the
 * left rail's job, not this bar's. Saved-filter presets are v1.1 (spec). */
@Component({
  selector: 'app-filter-bar',
  standalone: true,
  imports: [FormsModule, NgbTooltip],
  template: `
    <div class="filter-bar">
      <select class="bt-select filter-select" data-testid="filter-status" [(ngModel)]="status" (change)="emit()"
              ngbTooltip="Filter by ticket status. The default, Open, hides resolved and closed tickets">
        <option value="open">Open (new, active, pending)</option>
        <option [ngValue]="undefined">All statuses</option>
        <option value="new">New</option>
        <option value="active">Active</option>
        <option value="pending">Pending</option>
        <option value="resolved">Resolved</option>
        <option value="closed">Closed</option>
      </select>
      <select class="bt-select filter-select" data-testid="filter-priority" [(ngModel)]="priority" (change)="emit()"
              ngbTooltip="Filter by priority">
        <option [ngValue]="undefined">All priorities</option>
        <option value="critical">Critical</option>
        <option value="high">High</option>
        <option value="low">Low</option>
        <option value="feature_request">Feature request</option>
      </select>
      <div class="filter-search">
        <svg class="filter-search__icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="7"></circle><path d="m21 21-4.3-4.3"></path>
        </svg>
        <input class="bt-input filter-search__input" data-testid="filter-subject" [(ngModel)]="q" (input)="emit()"
               placeholder="Search subject…" ngbTooltip="Searches ticket subject only, not message bodies" />
      </div>
    </div>
  `,
  styles: [`
    .filter-bar { display: flex; align-items: center; gap: 0.6rem; }
    .filter-select { width: auto; min-width: 140px; }
    .filter-search { position: relative; flex: 1; min-width: 180px; }
    .filter-search__icon { position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: var(--bt-text-muted); pointer-events: none; }
    .filter-search__input { padding-left: 32px; }
  `],
})
export class FilterBarComponent {
  @Output() filtersChange = new EventEmitter<TicketListFilters>();
  /** Starts at the inbox default so the select shows the filter the first load used. */
  status?: string = DEFAULT_INBOX_STATUS;
  priority?: string;
  q?: string;

  emit(): void {
    this.filtersChange.emit({
      status: this.status as any, priority: this.priority as any, q: this.q,
    });
  }
}
